import { API_URL_WEBINAR } from "@constants/env";
import useApiCall from "@hooks/Shared/useApiCall";
import { IWebinar } from "@interfaces/webinar";

const useGetWebinar = (uuid: string) =>
  useApiCall<IWebinar>({
    url: API_URL_WEBINAR + uuid,
  });

export default useGetWebinar;
